import { render, staticRenderFns } from "./CalculationFormula.vue?vue&type=template&id=94162a5e"
import script from "./CalculationFormula.vue?vue&type=script&lang=js"
export * from "./CalculationFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports